import { combineReducers, createStore } from "redux";
import BuilderReducer from "./reducers/BuilderReducer";

const Store = createStore(combineReducers({
    builder:BuilderReducer
}),window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export default Store;